import { OrderLineInput, PaymentMethodType } from '../../core-types';
import { FormikErrors } from 'formik';

export interface Values {
  customerEmail: string;
  receiptEmail: string;
  tosAccepted: boolean;
  orderLines: OrderLineInput[];
  paymentMethodType: PaymentMethodType | null;
}

export function validate(values: Values): FormikErrors<Values> {
  const errors: FormikErrors<Values> = {};
  const orderLinesWithQuantity = values.orderLines.filter(
    orderLine => orderLine.quantity > 0
  );
  const haveOrderLines = orderLinesWithQuantity.length > 0;
  if (!haveOrderLines) {
    errors.orderLines = 'Select at least one product';
  }

  if (!values.customerEmail) {
    errors.customerEmail = 'Required';
  } else if (
    !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/i.test(
      values.customerEmail
    )
  ) {
    errors.customerEmail = 'Invalid email address';
  }

  if (values.receiptEmail) {
    if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/i.test(
        values.receiptEmail
      )
    ) {
      errors.receiptEmail = 'Invalid email address';
    }
  }

  if (!values.tosAccepted) {
    errors.tosAccepted = 'Required';
  }

  if (!values.paymentMethodType) {
    errors.paymentMethodType = 'Required';
  }

  return errors;
}
